import ApiHelpers from './api-helper';
import Helpers from './helpers';

const UmbracoAutomation = {
	init({ element }) {
		this.submitAutomation = document.getElementById('submitAutomation');
		this.baseUrl = '/umbraco/api/';
		this.apiUrl = element.dataset.apiUrl;
		this.applicationsApi = element.dataset.applicationsApi;
		this.automationGroup = element.dataset?.automationGroup;
		this.automationType = element.dataset?.automationType;
		this.needsDuplication = element.dataset?.needsDuplication;
		this.projectDropDown = document.getElementById('projectDropDown');
		this.projectApplications = document.getElementById('projectApplications');
		this.submitApplication = document.getElementById('submitApplication');
		this.applicationDropDown = document.getElementById('applicationDropDown');
		this.subscriptionDropdown = document.getElementById('subscriptionDropdown');
		this.newProjectDropDown = document.getElementById('newProjectDropDown');
		this.submitProject = document.getElementById('submitProject');
		this.submitButton = document.getElementById('submitButton');
		this.searchOrganization = document.getElementById('searchOrganization');
		this.searchProfessional = document.getElementById('searchProfessional');
		this.contactDropDown = document.getElementById('contactDropDown');
		this.contactKeyInput = document.getElementById('contactKeyInput');
		this.organizationSearchInput = document.getElementById('organizationSearchInput');
		this.organizationKeyInput = document.getElementById('organizationKeyInput');
		this.professionalKeyInput = document.getElementById('professionalKeyInput');
		this.sendRejectMail = document.getElementById('sendRejectMail');
		this.rejectionMessage = document.getElementById('rejectionMessage');
		this.emailInput = document.getElementById('emailAddressInput');
		this.emailAddress = document.getElementById('emailAddress');
		this.culture = document.documentElement.lang;
		if (this.apiUrl) {
			if (this.submitApplication) {
				document.getElementById('submitApplication').addEventListener('click', (e) => {
					e.preventDefault();
					this.handleGetApplication(this.selectedApplicationId);
				});
			}
			if (this.submitButton) {
				this.submitButton.setAttribute('disabled', true);
				if (this.automationType === 'Delete') {
					this.submitButton.addEventListener('click', (e) => {
						this.displayCheckPopup(e);
					});
				}
			}
			if (this.submitProject) {
				this.submitProject.addEventListener('click', (e) => {
					this.handleProjectSubmit(e);
				});
			}
			if (this.submitAutomation) {
				this.submitAutomation.addEventListener('submit', (e) => {
					this.handleSubmit(e);
				});
			}
		}
	},

	async getContactsForOrganization(organizationKey) {
		fetch(
			`${this.baseUrl}UmbracoAutomationsApi/GetContactsForOrganization?organizationKey=${organizationKey}`,
			{
				headers: { 'Content-Type': 'application/json', Culture: this.culture },
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error();
				}
				return response.json();
			})
			.then((results) => {
				if (results && results.length > 0) {
					this.populateDropDown(results, this.contactDropDown);
				} else {
					window.dispatchEvent(
						new CustomEvent('ping-ping', {
							detail: {
								heading: 'Oops! No contacts found',
								message: 'No contacts were found for this organization',
								emotion: 'sad',
							},
						})
					);
				}
			})
			.catch(() => {
				window.dispatchEvent(
					new CustomEvent('ping-ping', {
						detail: {
							heading: 'Hmmm, something went wrong',
							message: `Unfortunately something went wrong at the backend. Some kind of server error, you know the drill... Please try again later`,
							emotion: 'sad',
						},
					})
				);
			});
	},

	async getProjectsForOrganization(organizationKey) {
		this.organizationProjects = document.getElementById('organizationProjects');
		fetch(
			`${this.baseUrl}UmbracoAutomationsApi/GetProjectsForOrganization?organizationKey=${organizationKey}`,
			{
				headers: { 'Content-Type': 'application/json', Culture: this.culture },
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error();
				}
				return response.json();
			})
			.then((results) => {
				if (!results && !results.length > 0) {
					window.dispatchEvent(
						new CustomEvent('ping-ping', {
							detail: {
								heading: 'This does not work',
								message: 'No projects were found for this organization',
								emotion: 'sad',
							},
						})
					);
				} else {
					const projects = this.checkProjectState(results);
					if (projects && projects.length > 0) {
						if (this.projectDropDown) {
							this.populateDropDown(projects, this.projectDropDown);
						}
						if (this.newProjectDropDown) {
							this.populateDropDown(projects, this.newProjectDropDown);
						}
						if (
							this.organizationProjects &&
							this.organizationProjects.classList.contains('hidden')
						) {
							this.organizationProjects.classList.remove('hidden');
							if (this.searchProfessional) {
								this.searchProfessional.classList.remove('hidden');
							}
							if (!this.applicationDropDown && !this.searchProfessional) {
								this.submitButton.removeAttribute('disabled');
							}
						}
					} else {
						window.dispatchEvent(
							new CustomEvent('ping-ping', {
								detail: {
									heading: 'Sorry!',
									message: 'No projects were found that match the automation type you selected',
									emotion: 'sad',
								},
							})
						);
					}
				}
			})
			.catch(() => {
				window.dispatchEvent(
					new CustomEvent('ping-ping', {
						detail: {
							heading: 'Hmmm, something went wrong',
							message: `Unfortunately something went wrong at the backend. Some kind of server error, you know the drill... Please try again later`,
							emotion: 'sad',
						},
					})
				);
				if (this.organizationProjects && !this.organizationProjects.classList.contains('hidden')) {
					this.organizationProjects.classList.add('hidden');
				}
			});
	},

	async submitAutomationForm(formData) {
		await fetch(`${this.baseUrl}${this.apiUrl}`, {
			body: JSON.stringify(formData),
			headers: { 'Content-Type': 'application/json', Culture: this.culture },
			method: 'POST',
		})
			.then(async (response) => {
				if (!response.ok) {
					const contentType = response.headers.get('Content-Type');
					let errorMessage;

					if (contentType && contentType.includes('application/json')) {
						const json = await response.json();
						errorMessage = json.error || json.message || 'An unknown error occurred';
					} else {
						errorMessage = await response.text();
					}

					throw new Error(errorMessage);
				} else {
					Helpers.enableAllButtons();
					window.dispatchEvent(
						new CustomEvent('ping-ping', {
							detail: {
								heading: 'Great! The action has been executed :)',
								message: 'The action has been executed successfully #proud #yay',
								emotion: 'happy',
							},
						})
					);
				}
			})
			.catch((error) => {
				Helpers.enableAllButtons();
				window.dispatchEvent(
					new CustomEvent('ping-ping', {
						detail: {
							heading: 'Oops, something went wrong... Check the error below',
							message: error,
							emotion: 'sad',
						},
					})
				);
			});
	},

	fillApplicationInfo(data) {
		Object.entries(data).forEach(([key, value]) => {
			const pascalCaseKey = key.charAt(0).toUpperCase() + key.slice(1);
			const elements = document.getElementsByName(pascalCaseKey);
			if (elements.length > 0) {
				const element = elements[0];
				element.textContent = value;
			}
		});
	},

	fillSubscriptionForm(formData) {
		Object.entries(formData).forEach(([key, value]) => {
			const pascalCaseKey = key.charAt(0).toUpperCase() + key.slice(1); // Convert key to PascalCase
			const elements = document.getElementsByName(pascalCaseKey);

			if (elements.length > 0) {
				const element = elements[0];

				if (element.type === 'date') {
					// Convert the value to the correct date format for date inputs
					const dateObject = new Date(value);
					const dateValue = dateObject.toISOString().split('T')[0];
					element.value = dateValue;
				} else if (element.type === 'radio') {
					// Handle radio buttons by setting the checked property
					elements.forEach((radio) => {
						if (radio.value === `${value}`) {
							// eslint-disable-next-line no-param-reassign
							radio.checked = true;
						} else {
							// eslint-disable-next-line no-param-reassign
							radio.checked = false;
						}
					});
				} else {
					// Handle other input types
					element.value = value;
				}

				// Additional logic to handle specific cases
				if (pascalCaseKey === 'Type' && value === 6) {
					// Show the Funds section
					const fundsSection = document.querySelector('[data-toggle-target="Funds"]');
					if (fundsSection) {
						fundsSection.classList.add('is-visible');
					}

					// Set the FundKey value if available
					// eslint-disable-next-line no-underscore-dangle
					const _fundKey = formData.fundKey;
					const fundSelect = document.getElementsByName('FundKey')[0];
					if (fundSelect && _fundKey) {
						fundSelect.value = _fundKey;
					}
				} else if (pascalCaseKey === 'Type' && value !== 6) {
					// Hide the Funds section if not applicable
					const fundsSection = document.querySelector('[data-toggle-target="Funds"]');
					if (fundsSection) {
						fundsSection.classList.remove('is-visible');
					}
				}
			}
		});
	},

	handleSearch(el, targetKey) {
		if (el === this.searchOrganization) {
			this.getProjectsForOrganization(targetKey);
		} else if (el === this.searchProfessional) {
			this.professionalKeyInput.setAttribute('value', targetKey);
			if (this.emailAddress) {
				this.emailAddress.classList.remove('hidden');
				this.emailInput.addEventListener('focusout', () => {
					this.submitButton.removeAttribute('disabled');
				});
			} else {
				this.submitButton.removeAttribute('disabled');
			}
		} else if (el === this.organizationSearchInput) {
			this.organizationKeyInput.setAttribute('value', targetKey);
			if (el.dataset.searchContact) {
				this.getContactsForOrganization(targetKey);
			}
			if (el.dataset.searchSubscription) {
				this.handleGetSubscriptions(targetKey);
			}
		}
	},

	async getApplicationsForProject(projectKey) {
		fetch(`${this.baseUrl}${this.applicationsApi}?projectKey=${projectKey}`, {
			headers: { 'Content-Type': 'application/json', Culture: this.culture },
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error();
				}
				return response.json();
			})
			.then((results) => {
				if (results && results.length > 0) {
					if (this.applicationDropDown) {
						this.handleApplicationDropdown(results);
					}
					if (this.projectApplications && this.projectApplications.classList.contains('hidden')) {
						this.projectApplications.classList.remove('hidden');
						if (this.submitButton) {
							this.submitButton.removeAttribute('disabled');
						}
					}
				} else {
					window.dispatchEvent(
						new CustomEvent('ping-ping', {
							detail: {
								heading: 'Oops!',
								message: 'No applications were found for this project',
								emotion: 'sad',
							},
						})
					);
				}
			})
			.catch(() => {
				Helpers.enableAllButtons();
				if (this.submitButton) {
					this.submitButton.setAttribute('disabled', true);
				}
				window.dispatchEvent(
					new CustomEvent('ping-ping', {
						detail: {
							heading: 'Hmmm, something went wrong',
							message: `Unfortunately something went wrong at the backend. Some kind of server error, you know the drill... Please try again later`,
							emotion: 'sad',
						},
					})
				);
				if (this.projectApplications && !this.projectApplications.classList.contains('hidden')) {
					this.projectApplications.classList.add('hidden');
				}
			});
	},

	handleApplicationDropdown(results) {
		this.populateDropDown(results, this.applicationDropDown);
		if (this.submitApplication) {
			const applicationDropDown = document.getElementById('applicationDropDown');

			// Set the first option as selected by default
			if (applicationDropDown.options.length > 0) {
				applicationDropDown.selectedIndex = 0;
				this.selectedApplicationId = applicationDropDown.options[0].value;
			}

			applicationDropDown.addEventListener('change', (event) => {
				this.selectedApplicationId = event.target.value;
			});
		}
	},

	handleGetApplication(value) {
		const url = `UmbracoAutomationsApi/GetApplication`;
		const params = { applicationKey: value };
		const callback = (results) => {
			this.fillApplicationInfo(results);
			document.getElementById('applicationInfo')?.classList.remove('hidden');
		};
		const errorCallback = () => {
			Helpers.enableAllButtons();
		};
		ApiHelpers.get(url, params, callback, errorCallback);
	},

	handleGetSubscriptions(targetKey) {
		const url = `SubscriptionsApi/GetSubscriptionsBaseInfo`;
		const params = { organizationKey: targetKey };
		const callback = (results) => {
			this.handleSubscriptionDropdown(results.responseContent);
		};
		ApiHelpers.get(url, params, callback, null);
	},

	handleSubscriptionDropdown(results) {
		this.populateDropDown(results, this.subscriptionDropdown);
		document.getElementById('subscriptionDropdown').addEventListener('change', (event) => {
			const selectedSubscriptionId = event.target.value;
			this.handleGetSubscription(selectedSubscriptionId);
		});

		const firstOptionValue = this.subscriptionDropdown.options[0].value;
		this.handleGetSubscription(firstOptionValue);
	},

	handleGetSubscription(value) {
		const url = `SubscriptionsApi/GetSubscription`;
		const params = { subscriptionKey: value };
		const callback = (results) => {
			this.fillSubscriptionForm(results);
		};
		ApiHelpers.get(url, params, callback, null);
	},

	handleProjectSubmit(e) {
		e.preventDefault();
		const projectKey = this.projectDropDown?.value;
		this.getApplicationsForProject(projectKey);
	},

	displayCheckPopup(e) {
		e.preventDefault();
		window.dispatchEvent(
			new CustomEvent('lightbox-show-by-template-id', {
				detail: {
					templateId: 'doubleCheckSubmitPopup',
				},
			})
		);
		document.getElementById('doubleCheckSubmit').addEventListener('click', (event) => {
			this.handleSubmit(event);
			window.dispatchEvent(new CustomEvent('lightbox-close'));
		});
	},

	handleSubmit(e) {
		e.preventDefault();
		Helpers.disableAllButtons();
		if (this.automationGroup === 'Professional') {
			this.handleProfessionalAutomation();
		} else {
			const projectKey = this.projectDropDown?.value;
			if (this.automationGroup === 'Application') {
				this.handleApplicationAutomation(projectKey);
			} else {
				this.handleProjectAutomation(projectKey);
			}
		}
	},

	handleProfessionalAutomation() {
		const professionalKey = this.professionalKeyInput.value;
		let email = '';
		if (this.emailInput) {
			email = this.emailInput.value;
		}
		this.submitAutomationForm({
			professionalKey,
			professionalAutomationType: this.automationType,
			professionalEmail: email,
		});
	},

	handleApplicationAutomation(projectKey) {
		if (this.automationType !== 'Apply') {
			const applicationKey = this.applicationDropDown.value;
			let newProjectKey = null;
			if (this.newProjectDropDown) {
				newProjectKey = this.newProjectDropDown?.value;
			}
			let rejectionMessage = '';
			if (this.rejectionMessage) {
				rejectionMessage = this.rejectionMessage.value;
			}
			this.submitAutomationForm({
				projectKey,
				applicationAutomationType: this.automationType,
				applicationKey,
				newProjectKey,
				sendRejectMail: this.sendRejectMail.checked,
				rejectionMessage,
			});
		} else if (this.professionalKeyInput) {
			const professionalKey = this.professionalKeyInput.value;
			this.submitAutomationForm({
				projectKey,
				applicationAutomationType: this.automationType,
				professionalKey,
			});
		}
	},

	handleProjectAutomation(projectKey) {
		let rejectionMessage = '';
		if (this.rejectionMessage) {
			rejectionMessage = this.rejectionMessage.value;
		}
		this.submitAutomationForm({
			projectKey,
			projectAutomationType: this.automationType,
			sendRejectMail: this.sendRejectMail?.checked,
			rejectionMessage,
			needsDuplication: this.needsDuplication,
		});
	},

	populateDropDown(results, element) {
		const dropDownMenu = element;
		if (dropDownMenu.children.length > 0) {
			dropDownMenu.innerHTML = '';
		}
		results.forEach((r) => {
			const option = document.createElement('option');
			option.value = r.key;
			option.text =
				r.state && r.email
					? `${r.name} (${r.email}) | ${r.state}`
					: r.email
					? `${r.name} (${r.email})`
					: r.name;
			dropDownMenu.appendChild(option);
		});
	},

	checkProjectState(results) {
		switch (this.automationType) {
			case 'Abort':
			case 'Complete':
				return results.filter((result) => result.state === 'Matched' || result.state === 'Started');
			case 'Duplicate':
				return results;
			default:
				return results.filter((result) => result.state === 'Open' || result.state === 'Full');
		}
	},
};

export { UmbracoAutomation as default };
